<template>
    <div :id="collapseName" class="collapse" style="background:#3e3d40;">
        <div style="padding:20px;padding-bottom:50px;">
            <button type="button" 
                class="close" 
                style="margin-top:6px;margin-right:10px;"
                aria-label="Close" 
                @click="resetActor" data-toggle="collapse" 
                :data-target="anchorCollapseName()">
                <span aria-hidden="true" style="z-index:100;color:white;cursor:pointer;">&times;</span>
            </button>
            <!--<a class="pdf-link"
                target="_blank" 
                style="float:right;z-index:100;margin-right:40px;"
                :href="urlPdf()">
                    <i class="fa fa-print" style="font-size:1.3rem;padding-top:10px;"> </i>
            </a>-->

            <h1 class="my-1 font-bold text-center white-text mb-4" style="padding-left:10px" v-html="name"></h1>    

            <!--<router-view :actor="actor"></router-view>   -->
            <people-detail 
                v-if="details != null && details.length > 0" 
                :actor="actor" 
                :details="details"
                :matchedSize="matchedSize"
                :medien="medien"
                :auftrittsarten="auftrittsarten"
                :auftritte="auftritte"></people-detail>
                
        </div>
    </div>
</template>

<script>
import PeopleDetail from './PeopleDetail'
import {eventBus} from './../main'
import url from './../config'

export default {
    components: {
        peopleDetail: PeopleDetail
    },
    props: {
        'collapseName': {
            type: String
        },
        'actor': {
            type: Object
        },
        'matchedSize': {
            type: String
        },
        'isSameLineFn': {
            type: Function
        },
        'isSameActorFn': {
            type: Function
        }            
    },    
    data () {
        return {
            details: [],
            medien: [],
            auftrittsarten: [],
            auftritte: []
        }
    },
    computed: {
        name : function() {
            
            if (this.actor != null && this.actor.pv_id > -1) {
                //console.log("Load new Actor Details for actor " + this.actor.pv_id);
                //this.$http.get(url.scheme + '://service.heimanns-agentur.de/api/detail/' + this.actor.pv_id)
                this.$http.get(url.scheme + '://relaunch2018.heimanns-agentur.de/api/detail/' + this.actor.pv_id)
                    .then(response => {
                        return response.json();
                    })
                    .then(data => {
                        this.details = data.details;
                        this.medien = data.medien;
                        this.auftrittsarten = data.auftrittsarten;
                        this.auftritte = data.auftritte;
                        //console.log("All Details for actor " + this.actor.pv_id + " fetched from DB");
                        //console.log("Details: " + JSON.stringify(this.details));
                    });
                return this.actor.pv_vorname + ' ' + this.actor.pv_nachname;
            } else {
                return "Name is undefined";
            }

            
        }
    }, 
    methods: {
        anchorCollapseName() {
            return '#' + this.collapseName;
        },
        urlPdf() {
            return url.scheme + '://relaunch2018.heimanns-agentur.de/pdf/detailseite_pdf.php?id=' + this.actor.pv_id;
        },
        doSomethingOnHide(event) {
            //console.log("Hide " + this.collapseName);
            if (this.isSameLineFn(this.collapseName)) {
                //console.log("same line " + this.collapseName + " with actor: " + this.actor.pv_id);
                if (!this.isSameActorFn(this.actor.pv_id)) {
                    //console.log("preventDefault bei " + this.collapseName + " actor: " + this.actor.pv_id);
                    return false; 
                }
            } 
        },
        resetActor() {
            //console.log("Close Actor");
            window.scrollBy(0,-86);
            eventBus.$emit('selectActor', { line: this.collapseName, actor: this.actor });
        }
    },
    mounted() {
        var matched = this.matchedSize;

        $(this.anchorCollapseName()).on("hide.bs.collapse", this.doSomethingOnHide);
        $(this.anchorCollapseName()).on("hidden.bs.collapse", function(e){
            window.scrollBy(0,-280);
        });
        $(this.anchorCollapseName()).on('shown.bs.collapse', function (e) {
            //https://stackoverflow.com/questions/28433178/scrollintoview-preventing-other-listeners-from-triggering
            e.target.scrollIntoView({behaviour: 'smooth', block: 'start'}); 
                 
            //var viewportH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            
            if(matched === 'xs' || matched === 'sm') {
                
                window.scrollBy(0, -66); // Adjust scrolling with a negative value here
            } else {
                 window.scrollBy(0, -100); // Adjust scrolling with a negative value here
            }
           
        });
    }    
}
</script>

<style scoped>
    a.pdf-link {
        color: #888;
    }
    a.pdf-link:hover {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/components/PeopleRowActor.vue